import React from 'react';
import classNames from 'classnames';
import ShowHideToggle from 'utils/components/ShowHideToggle/ShowHideToggle';
import './ShowHidePanel.scss';

interface ShowHidePanelProps {
    shown: boolean;
    /*
     * Toggle button will be shown when this is true, or on hover
     */
    showToggleButton?: boolean;
    showTooltip?: string;
    hideTooltip?: string;
    onToggle: () => void;
}

export default function ShowHidePanel(props: ShowHidePanelProps) {
    const { shown, onToggle, showTooltip, hideTooltip, showToggleButton } =
        props;

    const tooltip = shown ? showTooltip : hideTooltip;

    return (
        <div
            className={classNames(
                'ShowHidePanel',
                shown ? 'is-shown' : 'is-hidden',
                showToggleButton && 'show-toggle-button'
            )}
        >
            <ShowHideToggle
                status={shown ? 'show' : 'hide'}
                hideLabel={true}
                tooltip={tooltip}
                onToggle={onToggle}
            />
        </div>
    );
}
